import React from 'react';
import MenuDotsIcon from '../icons/MenuDotsIcon';
import ArchiveIcon from '../icons/ArchiveIcon';
import { MenuButton, MenuDropdown, MenuItem } from '../../styles/ProjectCard.styles';
import CopyIcon from '../icons/CopyIcon';

const ProjectMenu = ({ showMenu, onMenuClick, onArchiveClick, onDuplicateClick, ref }) => (
    <div ref={ref}>
        <MenuButton
            onClick={onMenuClick}
            title="Project options"
        >
            <MenuDotsIcon />
        </MenuButton>

        {showMenu && (
            <MenuDropdown>
                <MenuItem onClick={onDuplicateClick}>
                    <CopyIcon />
                    Duplicate Project
                </MenuItem>
                <MenuItem onClick={onArchiveClick}>
                    <ArchiveIcon />
                    Archive project
                </MenuItem>
            </MenuDropdown>
        )}
    </div>
);

export default ProjectMenu;